import { Component, Input } from '@angular/core';
import { TreeViewItem } from '../../models/tree-view-item.interface';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent } from '@aft/frogo-kit/components/icon/icon.component';

@Component({
    selector: 'fk-tree-view-item',
    templateUrl: './tree-view-item.component.html',
    styleUrls: ['./tree-view-item.component.scss'],
    imports: [RouterLink, RouterLinkActive, IconComponent],
})
export class TreeViewItemComponent {
  @Input()
  item!: TreeViewItem;

  @Input()
  isLastItem = false;

  @Input()
  isRootItem = false;

  @Input()
  minimized = false;

  constructor(
    protected router: Router,
  ) {}
}
